import i18n from '@/libs/i18n'

export default [
  {
    id: 'nav-referral-program',
    title: i18n.t('layout.textReferral'),
    route: 'referral-introduce',
    icon: 'AwardIcon',
    tooltip: i18n.t('layout.textReferral'),
  },
  // {
  //   id: 'nav-partner-contact',
  //   title: i18n.t('layout.textPartnerContact'),
  //   route: 'referral-partner-info',
  //   icon: 'ClipboardIcon',
  //   tooltip: i18n.t('layout.textPartnerContact'),
  // },
]
